import React from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { AsyncPaginate } from "react-select-async-paginate";
import CustomDate from "../../UI/forms/CustomDate";
import MobileInput from "../../UI/forms/MobileInput";
import LoadingButton from "../../UI/LoadingButton";
import instance from "../../../axiosInstance";

const loadUserOptions = async (search, loadedOptions, { page }) => {
  try {
    const res = await instance.get("/user/lists", {
      params: { search, page: page || 1, limit: 10 },
    });
    const { data } = res.data;
    const options = (data.data || []).map((user) => ({
      value: user.user_id,
      label: user.full_name,
    }));
    return {
      options,
      hasMore: (page || 1) < (data.total_pages || 1),
      additional: { page: (page || 1) + 1 },
    };
  } catch {
    return { options: [], hasMore: false };
  }
};

const Notes = ({
  isAddNotActive,
  setIsAddNotActive,
  isAddNoteOnCallActive,
  setIsAddNoteOnCallActive,
  isAddAsReminderActive,
  setIsAddAsReminderActive,
  isSendEmailActive,
  setIsSendEmailActive,
  isSendSMSActive,
  setIsSendSMSActive,
  isTaskActive = false,
  setIsTaskActive = () => {},
  taskUsers = [],
  setTaskUsers = () => {},
  noteDescription,
  setNoteDescription,
  addNoteTo,
  setAddNoteTo,
  addAsReminderDate,
  setAddAsReminderDate,
  reminderUsers,
  setReminderUsers,
  sendEmailTo,
  setSendEmailTo,
  sendSMSTo,
  setSendSMSTo,
  sendSMSMobile,
  setSendSMSMobile,
  validationErrors,
  setValidationErrors,
}) => {
  
  return (
    <>
      <hr className="mt-4" />
      <Row>
        <Col md={4}>
          <FormGroup className="p-2">
            <div className="d-flex justify-between align-items-center w-100">
              <div className="col-md-6 p-0">
                <Label for="notes">Notes</Label>
              </div>
              <div className="col-md-6 p-0" style={{ textAlign: "end" }}>
                {/* <Input type="checkbox" id="addNoteOnCall" checked={isAddNoteOnCallActive} onClick={(e) => setIsAddNoteOnCallActive(e.target.checked)} />
                <Label for="addNoteOnCall">On Call</Label> */}
                {/* <LoadingButton>
                  On Call
                </LoadingButton> */}
              </div>
            </div>
            <Input type="textarea" rows="5" cols="40" id="notes" value={noteDescription} onChange={(e) => setNoteDescription(decodeURIComponent(encodeURIComponent(e.target.value)))} />
          </FormGroup>
        </Col>

        <Col className="pt-20">
          <Row className="m-0 pl-2">
            <Col md={2}>
              <Input type="checkbox" id="addNote" checked={isAddNotActive} onClick={(e) => setIsAddNotActive(e.target.checked)} />
              <Label for="addNote">Add Note</Label>
            </Col>

            {isAddNotActive && (
              <>
                <Col md={3} sm={4}>
                  <Input
                    type="checkbox"
                    id="displayToDEO"
                    checked={addNoteTo.displayToDEO}
                    onClick={() =>
                      setAddNoteTo({
                        ...addNoteTo,
                        displayToDEO: !addNoteTo.displayToDEO,
                      })
                    }
                  />
                  <Label for="displayToDEO">Display to DEO</Label>
                </Col>
                <Col md={3} sm={4}>
                  <Input
                    type="checkbox"
                    id="displayToClient"
                    checked={addNoteTo.displayToClient}
                    onClick={() =>
                      setAddNoteTo({
                        ...addNoteTo,
                        displayToClient: !addNoteTo.displayToClient,
                      })
                    }
                  />
                  <Label for="displayToClient">Display to Client</Label>
                </Col>
                <Col md={3} sm={4}>
                  <Input
                    type="checkbox"
                    id="displayToCHO"
                    checked={addNoteTo.displayToCHO}
                    onClick={() =>
                      setAddNoteTo({
                        ...addNoteTo,
                        displayToCHO: !addNoteTo.displayToCHO,
                      })
                    }
                  />
                  <Label for="displayToCHO">Display to CHO</Label>
                </Col>
              </>
            )}
          </Row>

          <Row className="m-0 pl-2">
            <Col md={3} sm={3}>
              <Input type="checkbox" id="addAsReminder" checked={isAddAsReminderActive} onClick={(e) => setIsAddAsReminderActive(e.target.checked)} />
              <Label for="addAsReminder">Add as Reminder</Label>
            </Col>

            {isAddAsReminderActive && (
              <>
                <Col md={4} sm={4} style={{ marginLeft: "-18px" }}>
                  <Label for="addAsReminderDate">Date & Time:</Label>
                  <br />
                  <CustomDate
                    startDate={addAsReminderDate}
                    setStartDate={setAddAsReminderDate}
                    id={"addAsReminderDate"}
                    className="ml-2"
                    placeholder="Select Date & Time"
                    dateFormat="dd-MM-yyyy HH:mm"
                    timeFormat="HH:mm"
                    showTimeSelect
                    size="medium"
                    timeIntervals={10}
                  />
                </Col>
                <Col md={5} sm={5}>
                  <Label for="reminderUsers" className="mr-2">Users:</Label>
                  <AsyncPaginate
                    isMulti
                    value={reminderUsers}
                    additional={{ page: 1 }}
                    loadOptions={loadUserOptions}
                    onChange={setReminderUsers}
                    debounceTimeout={300}
                    placeholder="Search and select users..."
                    styles={{
                      control: (base) => ({ ...base, borderRadius: 6, minHeight: 38 }),
                      menu: (base) => ({ ...base, zIndex: 10 }),
                    }}
                    className="flex-grow-1"
                    size="sm"
                  />
                </Col>
              </>
            )}
          </Row>

          <Row className="m-0 pl-2">
            <Col md={4}>
              <Input type="checkbox" id="sendEmail" checked={isSendEmailActive} onClick={(e) => setIsSendEmailActive(e.target.checked)} />
              <Label for="sendEmail">Send Email</Label>
            </Col>

            {isSendEmailActive && (
              <>
                <Col md={4} sm={4}>
                  <Input type="checkbox" id="source" checked={sendEmailTo.source} onClick={() => setSendEmailTo({ ...sendEmailTo, source: !sendEmailTo.source })} />
                  <Label for="source">Source</Label>
                </Col>

                <Col md={4} sm={4}>
                  <Input type="checkbox" id="client" checked={sendEmailTo.client} onClick={() => setSendEmailTo({ ...sendEmailTo, client: !sendEmailTo.client })} />
                  <Label for="client">Client</Label>
                </Col>
              </>
            )}
          </Row>

          <Row className="m-0 pl-2">
            <Col md={4}>
              <Input
                type="checkbox"
                id="sendSMS"
                checked={isSendSMSActive}
                onClick={() => {
                  setIsSendSMSActive((prev) => {
                    if (prev === true) setSendSMSTo(null);
                    return !prev;
                  });
                }}
              />
              <Label for="sendSMS">Send SMS</Label>
            </Col>

            <Col>
              <Row>
                {isSendSMSActive && (
                  <>
                    <Col md={4} sm={4}>
                      <Input type="radio" id="leadSource" name="sendSMS" checked={sendSMSTo === "leadSource"} onClick={() => setSendSMSTo("leadSource")} />
                      <Label for="leadSource">Lead Source</Label>
                    </Col>
                    <Col md={4} sm={4}>
                      <Input type="radio" id="sendToClient" name="sendSMS" checked={sendSMSTo === "client"} onClick={() => setSendSMSTo("client")} />
                      <Label for="sendToClient">Send To Client</Label>
                    </Col>
                    <Col md={4} sm={4}>
                      <Input type="radio" id="mobileNumber" name="sendSMS" checked={sendSMSTo === "mobileNumber"} onClick={() => setSendSMSTo("mobileNumber")} />
                      <Label for="mobileNumber">Mobile Number</Label>
                    </Col>
                  </>
                )}

                {sendSMSTo === "client" && (
                  <Col md={6} sm={6}>
                    <input type="hidden"
                      label="Client Number"
                      mame="clientNumberInput"
                      value={sendSMSMobile?.clientNumber || ""}
                      onChange={(value) => setSendSMSMobile((prevState) => ({ ...prevState, clientNumber: value }))}
                      isInvalid={validationErrors?.clientNumber}
                      setError={[setValidationErrors, "clientNumber"]}
                    />
                  </Col>
                )}

                {sendSMSTo === "mobileNumber" && (
                  <Col md={6} sm={6}>
                    <MobileInput
                      label="Mobile Number"
                      mame="mobileNumberInput"
                      value={sendSMSMobile?.mobileNumber || ""}
                      onChange={(value) => setSendSMSMobile((prevState) => ({ ...prevState, mobileNumber: value }))}
                      isInvalid={validationErrors?.mobileNumber}
                      setError={[setValidationErrors, "mobileNumber"]}
                    />
                  </Col>
                )}
              </Row>
            </Col>
          </Row>

          <Row className="m-0 pl-2">
            <Col md={4}>
              <Input
                type="checkbox"
                id="taskNote"
                checked={isTaskActive}
                onClick={(e) => {
                  const v = e.target.checked;
                  setIsTaskActive(v);
                  if (!v) setTaskUsers([]);
                }}
              />
              <Label for="taskNote">Task</Label>
            </Col>
            {isTaskActive && (
              <Col md={8} sm={8} className="d-flex align-items-center flex-wrap">
                <Label for="taskUsers" className="mr-2 mb-0">
                  Assign to:
                </Label>
                <AsyncPaginate
                  isMulti
                  value={taskUsers}
                  additional={{ page: 1 }}
                  loadOptions={loadUserOptions}
                  onChange={setTaskUsers}
                  debounceTimeout={300}
                  placeholder="Search and select users..."
                  styles={{
                    control: (base) => ({ ...base, borderRadius: 6, minHeight: 38 }),
                    menu: (base) => ({ ...base, zIndex: 10 }),
                  }}
                  className="flex-grow-1"
                  inputId="taskUsers"
                />
              </Col>
            )}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Notes;
